import superagent from 'superagent';
import uuidv4 from 'uuid/v4';
import moment from 'moment';
import WebSocket from 'reconnecting-websocket';
import { debounce } from 'lodash';

import * as types from './types';
import { userLogout, forbiddenAccess, checkVersionMisMatch } from './auth';
import store from '../store';

let activeConversationRequest = null;
let ws;

const request = superagent
  .agent()
  .set('ETag', window.Config.APP_VERSION)
  .use(function (req) {
    req.on('response', function (res) {
      if (res.status === 401) {
        console.log('UnAuthorized');
        const { dispatch } = store;
        dispatch(userLogout());
      } else if (res.status === 403) {
        console.log('Forbidden');
        forbiddenAccess();
      }
    });
  });

export function getConversations(businessId, loadmore) {
  return (dispatch, getState) => {
    let no_of_days = 30;
    let startdate = moment()
      .startOf('day')
      .subtract(no_of_days, 'd');
    startdate = Math.round(new Date(startdate).getTime());
    let endDate = Math.round(new Date().getTime());
    if (loadmore) {
      endDate = loadmore;
    }
    const params = Object.assign(
      {},
      {
        start: startdate,
        end: endDate,
        business_id: businessId,
        count: loadmore ? 100 : 300,
      },
    );
    dispatch(getConversationsStart(loadmore));
    request
      .get(`${window.Config.API_URL}/livedashboard/business/sessions`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .query(params)
      .then((resp) => {
        if (resp.statusCode === 200) {
          if (!loadmore && resp.body.length === 0) {
            dispatch(getConversations(businessId, true));
          }
          dispatch(
            getConversationsSuccess(resp.body, no_of_days, false, loadmore),
          );
          dispatch(checkVersionMisMatch(resp.headers));
        } else {
          dispatch(getConversationsFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(getConversationsFail());
      });
  };
}
export function getConversationsStart(loadmore) {
  return {
    type: types.GET_CONVERSATION_START,
    loadmore,
  };
}

export function getConversationsSuccess(
  conversation,
  no_of_days,
  search,
  loadmore,
) {
  return {
    type: types.GET_CONVERSATION_SUCCESS,
    conversations: conversation.sessions || [],
    counts: {
      all_assigned_user_ids: conversation.all_assigned_user_ids || [],
      mine_user_ids: conversation.mine_user_ids || [],
      total_user_ids: conversation.total_user_ids || [],
      unassigned_user_ids: conversation.unassigned_user_ids || [],
    },
    loadmore,
    no_of_days,
    search,
  };
}

export function getConversationsFail() {
  return {
    type: types.GET_CONVERSATION_FAIL,
  };
}

export function clearSearch() {
  return {
    type: types.CLEAR_SEARCH,
  };
}

const postConversationStatusStart = () => {
  return {
    type: types.SET_STATUS_START,
  };
};

const postConversationStatusSuccess = (data) => {
  return {
    type: types.SET_STATUS_SUCCESS,
    ...data,
  };
};

const postConversationStatusFail = () => {
  return {
    type: types.SET_STATUS_FAIL,
  };
};

const postmarkResolveClear = () => {
  return {
    type: types.MARK_RESOLVE_CLEAR,
  };
};

export function markResolveClear() {
  return (dispatch) => {
    dispatch(postmarkResolveClear());
  };
}
export function postConversationStatus({ businessId, sessionId, data }) {
  return (dispatch) => {
    dispatch(postConversationStatusStart());

    request
      .post(
        `${window.Config.API_URL}/livedashboard/business/session/${sessionId}/status`,
      )
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(data)
      .then((resp) => {
        dispatch(postConversationStatusSuccess({ sessionId, data: resp.body }));
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(postConversationStatusFail());
      });
  };
}

export function editCallerName(name, businessId, clientId, userId) {
  console.log(name, businessId, clientId, userId);
  return (dispatch) => {
    const index = name.indexOf(' ');

    let first_name;
    let last_name;
    if (index !== -1) {
      first_name = name.slice(0, index);
      last_name = name.slice(index + 1);
    } else {
      first_name = name;
      last_name = '';
    }
    const data = {
      user: {
        first_name,
        last_name,
      },
      user_id: userId,
      client_id: clientId,
    };
    dispatch(postEditCallerNameStart());
    request
      .post(
        `${window.Config.API_URL}/livedashboard/business/${businessId}/caller_name`,
      )
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(data)
      .then((resp) => {
        dispatch(postEditCallerNameSuccess(resp.body));
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(postEditCallerNameFail());
      });
  };
}
const postEditCallerNameStart = () => {
  return {
    type: types.SET_CALLER_NAME_START,
  };
};

const postEditCallerNameSuccess = (data) => {
  return {
    type: types.SET_CALLER_NAME_SUCCESS,
    data,
  };
};

const postEditCallerNameFail = () => {
  return {
    type: types.SET_CALLER_NAME_FAIL,
  };
};

const getClientInformationSuccess = (data) => {
  return {
    type: types.GET_CLIENT_INFO_SUCCESS,
    data,
  };
};

export function getClientInformation({ businessId, clientId }) {
  return (dispatch, getState) => {
    dispatch({
      type: types.GET_CLIENT_INFO_START,
    });

    request
      .get(`${window.Config.API_URL}/livedashboard/business/client/${clientId}`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .then((resp) => {
        dispatch(getClientInformationSuccess(resp.data));
      })
      .catch((ex) => {
        console.log('Failed to fetch client information: ', ex);
        dispatch({
          type: types.GET_CLIENT_INFO_FAIL,
        });
      });
  };
}

export function searchConversation(businessId, searchText, isUserId) {
  return (dispatch, getState) => {
    let no_of_days = 90;
    let startdate = moment()
      .startOf('day')
      .subtract(no_of_days, 'd');
    startdate = Math.round(new Date(startdate).getTime());
    const endDate = Math.round(new Date().getTime());
    const cleanPhoneNumber = searchText.replace(/[^\d+]/g, ''); // Remove all characters except digits and "+"
    const isPhoneNumber = /^\+?\d+$/.test(cleanPhoneNumber); // Ch
    let params = Object.assign(
      {},
      {
        start_time: startdate,
        end_time: endDate,
        business_id: businessId,
        ...(isUserId
          ? { user_id: searchText } // If isUserId is true, use user_id
          : isPhoneNumber
            ? { user_phone: cleanPhoneNumber } // If phone number, use user_phone
            : { user_name: searchText }),
      },
    );

    dispatch(searchConversationsStart());
    request
      .post(`${window.Config.API_URL}/livedashboard/business/client/sessions`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .set('Content-Type', 'application/json')
      .send(params)
      .then((resp) => {
        if (resp.statusCode === 200) {
          dispatch(searchConversationsSuccess(resp.body, searchText));
        } else {
          dispatch(searchConversationsFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(searchConversationsFail());
      });
  };
}

export function searchConversationsStart() {
  return {
    type: types.POST_CONVERSATION_SEARCH_START,
  };
}

export function searchConversationsSuccess(searchResults, searchText) {
  return {
    type: types.POST_CONVERSATION_SEARCH_SUCCESSS,
    searchResults,
    searchText,
  };
}

export function searchConversationsFail() {
  return {
    type: types.POST_CONVERSATION_SEARCH_FAIL,
  };
}

const getClientAppointmentsSuccess = (data) => {
  return {
    type: types.GET_CLIENT_APPOINTMENTS_SUCCESS,
    data,
  };
};

export function getClientAppointments({
  businessId,
  clientId,
  start,
  end,
  domain,
}) {
  return (dispatch, getState) => {
    dispatch({
      type: types.GET_CLIENT_APPOINTMENTS_START,
    });

    const { business } = getState();
    const { staffById, serviceById } = business;
    let tail = 'appointments';
    if (domain === 'FITNESS') {
      tail = 'visits';
      start = moment()
        .startOf('day')
        .subtract(14, 'd')
        .format('YYYY-MM-DDTHH:mm:ss');
    }

    const params = {
      start_time: start,
      end_time: end,
    };

    request
      .get(
        `${window.Config.API_URL}/livedashboard/business/client/${clientId}/${tail}`,
      )
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .query(params)
      .then((resp) => {
        const data = JSON.parse(resp.text);
        for (let i = 0, l = data.length; i < l; i += 1) {
          const staff = staffById[data[i].staff_id] || {};
          const service = serviceById[data[i].service_id] || {};
          data[i].staff_name = staff.name || '';
          data[i].service_name = service.name || '';
        }

        dispatch(getClientAppointmentsSuccess(data));
      })
      .catch((ex) => {
        console.log('Failed to fetch client appointments: ', ex);
        dispatch({
          type: types.GET_CLIENT_APPOINTMENTS_FAIL,
        });
      });
  };
}

const getClientNotesSuccess = (data) => {
  return {
    type: types.GET_CLIENT_NOTES_SUCCESS,
    ...data,
  };
};

export function getClientNotes({ businessId, sessionId }) {
  return (dispatch, getState) => {
    dispatch({
      type: types.GET_CLIENT_NOTES_START,
    });

    request
      .get(
        `${window.Config.API_URL}/livedashboard/business/session/${sessionId}/notes`,
      )
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .then((resp) => {
        dispatch(getClientNotesSuccess(resp.body));
      })
      .catch((ex) => {
        console.log('Failed to fetch client notes: ', ex);
        dispatch({
          type: types.GET_CLIENT_NOTES_FAIL,
        });
      });
  };
}

const postClientNotesSuccess = (data, sessionId) => {
  return {
    type: types.POST_CLIENT_NOTES_SUCCESS,
    data,
    sessionId,
  };
};

export function postClientNotes({ businessId, sessionId, notes }) {
  return (dispatch, getState) => {
    dispatch({
      type: types.POST_CLIENT_NOTES_START,
    });
    request
      .post(
        `${window.Config.API_URL}/livedashboard/business/session/${sessionId}/notes`,
      )
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(notes)
      .ok((resp) => resp.status < 405)
      .then((resp) => {
        if (resp.statusCode === 200) {
          dispatch(postClientNotesSuccess(resp.body, sessionId));
        } else if (resp.status === 404) {
          dispatch({
            type: types.POST_CLIENT_NOTES_FAIL,
            errorMessage: resp.text,
          });
        }
      })
      .catch((ex) => {
        console.log('Failed to update client notes: ', ex);
        dispatch({
          type: types.POST_CLIENT_NOTES_FAIL,
        });
      });
  };
}

export function getConversationSummary(businessId) {
  return (dispatch, getState) => {
    let no_of_days = 30;
    let startdate = moment()
      .startOf('day')
      .subtract(no_of_days, 'd');
    startdate = Math.round(new Date(startdate).getTime());
    let endDate = Math.round(new Date().getTime());
    const params = Object.assign(
      {},
      {
        start: startdate,
        end: endDate,
        business_id: businessId,
      },
    );
    dispatch(getConversationSummaryStart());
    request
      .get(`${window.Config.API_URL}/livedashboard/business/sessions/summary`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .query(params)
      .then((resp) => {
        if (resp.statusCode === 200) {
          dispatch(getConversationSummarySuccess(resp.body));
          dispatch(checkVersionMisMatch(resp.headers));
        } else {
          dispatch(getConversationSummaryFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(getConversationSummaryFail());
      });
  };
}

const getConversationSummaryStart = () => {
  return {
    type: types.GET_CONVERSATION_SUMMARY_START,
  };
};
const getConversationSummarySuccess = (response) => {
  return {
    type: types.GET_CONVERSATION_SUMMARY_SUCCESS,
    conversationSummary: response,
  };
};
const getConversationSummaryFail = () => {
  return {
    type: types.GET_CONVERSATION_SUMMARY_FAIL,
  };
};

export function getConversationDetails({ businessId, sessionId, rootid, selectedConversation }) {
  return (dispatch) => {
    // Cancel previous request if exists
    if (activeConversationRequest) {
      activeConversationRequest.abort();
    }

    dispatch(getConversationDetailsStart());

    // Create new request
    activeConversationRequest = request
      .post(`${window.Config.API_URL}/livedashboard/business/sessions`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send({ session_ids: sessionId });

    activeConversationRequest
      .then((resp) => {
        if (resp.statusCode === 200) {
          let root = {};
          if (resp.body.length > 0) {
            root = resp.body.find((details) => details.id === rootid) || {};
            root.voice_calls = (root.voice_calls || []).map((obj) => ({
              ...obj,
              tags: root.tags,
              status: root.status,
            }));
            root.allBookings = [];
            root.allTags = [];
            // Process all responses
            resp.body.forEach((item) => {
              root.allBookings = root.allBookings.concat(item.bookings);
              root.allTags = root.allTags.concat(item.tags);
              if (item.id !== rootid) {
                root.messages = root.messages.concat(item.messages) || [];
                root.events = root.events.concat(item.events) || [];
                // let voice_calls_updated = [];
                item.voice_calls = (item.voice_calls || []).map((obj) => ({
                  ...obj,
                  tags: item.tags,
                  status: item.status,
                }));
                console.log('voice_calls 3', item.tags, item.voice_calls);
                root.voice_calls = root.voice_calls.concat(item.voice_calls) || [];
                root.notifications = root.notifications.concat(item.notifications) || [];
                root.notes.conversation_notes = root.notes.conversation_notes.concat(
                  item.notes.conversation_notes,
                ) || [];
              }
            });

            // Check for selected conversation messages
            if (selectedConversation?.details?.messages?.length > root.messages.length) {
              root.messages = selectedConversation.details.messages;
            }

            // Sort and deduplicate bookings
            root.allBookings = root.allBookings
              .sort((a, b) => (a.timestamp > b.timestamp ? 1 : -1))
              .reduce((unique, booking) => {
                if (!unique.some((obj) => obj.appointment_id === booking.appointment_id)) {
                  unique.push(booking);
                }
                return unique;
              }, []);

            // Sort messages and notifications
            root.messages.sort((a, b) => (a.timestamp > b.timestamp ? 1 : -1));
            root.voice_calls.sort(function (a, b) {
              return a.timestamp > b.timestamp ? 1 : -1;
            });
            root.notifications.sort((a, b) => (a.timestamp > b.timestamp ? 1 : -1));

            // Take only first conversation note if exists
            if (root.notes.conversation_notes[0]) {
              root.notes.conversation_notes = [root.notes.conversation_notes[0]];
            }
          } else {
            // Handle empty response
            root = {
              ...selectedConversation,
              messages: [],
              notifications: [],
              voice_mails: [],
              voice_calls: [],
              allTags: [],
              donotCache: true,
            };
          }

          dispatch(getConversationDetailsSuccess(root));
          dispatch(checkVersionMisMatch(resp.headers));
        } else {
          dispatch(getConversationDetailsFail());
        }
      })
      .catch((error) => {
        // Only dispatch failure if it's not an abort error
        if (error.code !== 'ABORTED') {
          dispatch(getConversationDetailsFail());
        }
      })
      .finally(() => {
        const currentRequest = activeConversationRequest;
        // Only clear if this is still the active request
        if (currentRequest && currentRequest === activeConversationRequest) {
          activeConversationRequest = null;
        }
      });

    // Return the request for potential chaining
    return activeConversationRequest;
  };
}

const debouncedApiCall = debounce((params, dispatch) => {
  const { businessId, sessionId, rootid, convuserId, selectedConversation, search } = params;
  // Clear any pending debounce timer
  dispatch(getConversationDetailsStart(convuserId));
  console.log('Transcript Request', convuserId);
  const start_offset = search ? 90 : 60;
  const apiRequest = request
    .get(`${window.Config.API_URL}/livedashboard/business/${businessId}/user/${convuserId}/sessions?start_time=${moment().subtract('days', start_offset).startOf('day').toISOString()}&end_time=${moment().add(30, 'minutes').toISOString()}`)
    .withCredentials()
    .set('X-Request-ID', uuidv4())
    .timeout(30000)
    .send({ session_ids: sessionId });

  apiRequest
    .then((response) => {
      if (response.statusCode === 200) {
        let root = {};
        let resp = {};
        resp.body = response?.body?.sessions_with_contents || [];
        if (resp.body.length > 0) {
          root = resp.body.find((details) => details.id === rootid) || {};
          root.voice_calls = root.voice_calls.map((obj) => ({
            ...obj,
            tags: root.tags,
            status: root.status,
            initiatedFor: root.initiatedFor,
          }));
          root.allBookings = [];
          root.user_tags = response?.body?.user_tags || [];

          // Process all responses
          resp.body.forEach((item) => {
            root.allBookings = root.allBookings.concat(item.bookings);
            if (item.id !== rootid) {
              root.messages = root.messages.concat(item.messages);
              root.events = root.events.concat(item.events);
              item.voice_calls = item.voice_calls.map((obj) => ({
                ...obj,
                tags: item.tags,
                status: item.status,
                initiatedFor: item.initiatedFor,
              }));
              console.log('voice_calls 3', item.tags, item.voice_calls);
              root.voice_calls = root.voice_calls.concat(item.voice_calls);
              root.notifications = root.notifications.concat(item.notifications);
              root.notes.conversation_notes = root.notes.conversation_notes.concat(
                item.notes.conversation_notes,
              );
            }
          });

          // Check for selected conversation messages
          if (selectedConversation?.details?.messages?.length > root.messages.length) {
            root.messages = selectedConversation.details.messages;
          }

          // Sort and deduplicate bookings
          root.allBookings = root.allBookings
            .sort((a, b) => (a.timestamp > b.timestamp ? 1 : -1))
            .reduce((unique, booking) => {
              if (!unique.some((obj) => obj.appointment_id === booking.appointment_id)) {
                unique.push(booking);
              }
              return unique;
            }, []);

          // Sort messages and notifications
          root.messages.sort((a, b) => (a.timestamp > b.timestamp ? 1 : -1));
          root.voice_calls.sort(function (a, b) {
            return a.timestamp > b.timestamp ? 1 : -1;
          });
          root.notifications.sort((a, b) => (a.timestamp > b.timestamp ? 1 : -1));

          // Take only first conversation note if exists
          if (root.notes.conversation_notes[0]) {
            root.notes.conversation_notes = [root.notes.conversation_notes[0]];
          }
        } else {
          // Handle empty response
          root = {
            ...selectedConversation,
            messages: [],
            notifications: [],
            voice_mails: [],
            voice_calls: [],
            donotCache: true,
          };
        }
        console.log('Transcript Response', root);
        dispatch(getConversationDetailsSuccess(root, convuserId));
        dispatch(checkVersionMisMatch(resp.headers));
      } else {
        dispatch(getConversationDetailsFail(convuserId));
      }
    })
    .catch((error) => {
      dispatch(getConversationDetailsFail(convuserId));
    });
}, 250);

export function getConversationDetailsbyUser(params) {
  return (dispatch) => {
    debouncedApiCall(params, dispatch);
    return Promise.resolve();
  };
}

export function getConversationDetailsStart(convuserId) {
  return {
    type: types.GET_CONVERSATION_DETAILS_START,
    convuserId,
  };
}

export function getConversationDetailsSuccess(data, convuserId) {
  return {
    type: types.GET_CONVERSATION_DETAILS_SUCCESS,
    data,
    convuserId,
  };
}

export function getConversationDetailsFail(convuserId) {
  return {
    type: types.GET_CONVERSATION_DETAILS_FAIL,
    convuserId,
  };
}

export function getClientDetails({ businessId, clients }) {
  return (dispatch) => {
    dispatch(getClientDetailsStart());

    request
      .post(`${window.Config.API_URL}/livedashboard/business/clients`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send({ client_ids: clients })
      .then((resp) => {
        if (resp.statusCode === 200) {
          dispatch(getClientDetailsSuccess(JSON.parse(resp.text)));
        } else {
          dispatch(getClientDetailsFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(getClientDetailsFail());
      });
  };
}

export function getClientDetailsStart() {
  return {
    type: types.GET_CLIENT_DETAILS_START,
  };
}

export function getClientDetailsSuccess(data) {
  return {
    type: types.GET_CLIENT_DETAILS_SUCCESS,
    data,
  };
}

export function getClientDetailsFail() {
  return {
    type: types.GET_CLIENT_DETAILS_FAIL,
  };
}

export function getAssignedConversation() {
  return (dispatch) => {
    dispatch(getAssignedConversationStart());

    request
      .get(`${window.Config.API_URL}/livedashboard/business/assignments`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .then((resp) => {
        if (resp.statusCode === 200) {
          dispatch(getAssignedConversationSuccess(JSON.parse(resp.text)));
        } else {
          dispatch(getAssignedConversationFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(getAssignedConversationFail());
      });
  };
}

export function getAssignedConversationStart() {
  return {
    type: types.GET_ASSIGNED_CONVERSATIONS_START,
  };
}

export function getAssignedConversationSuccess(data) {
  return {
    type: types.GET_ASSIGNED_CONVERSATIONS_SUCCESS,
    data,
  };
}

export function getAssignedConversationFail() {
  return {
    type: types.GET_ASSIGNED_CONVERSATIONS_FAIL,
  };
}

export function assignConversation(session_id, assigned_to, user_id) {
  return (dispatch) => {
    dispatch(assignConversationStart());

    request
      .post(`${window.Config.API_URL}/livedashboard/business/assignments`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send({
        session_id,
        assigned_to,
        user_id,
      })
      .then((resp) => {
        if (resp.statusCode === 200) {
          dispatch(assignConversationSuccess(JSON.parse(resp.text), {
            session_id,
            assigned_to,
            user_id,
          }));
        } else {
          dispatch(assignConversationFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(assignConversationFail());
      });
  };
}

export function assignConversationStart() {
  return {
    type: types.POST_ASSIGN_CONVERSATIONS_START,
  };
}

export function assignConversationSuccess(data, requestParam) {
  return {
    type: types.POST_ASSIGN_CONVERSATIONS_SUCCESS,
    data,
    requestParam,
  };
}

export function assignConversationFail() {
  return {
    type: types.POST_ASSIGN_CONVERSATIONS_FAIL,
  };
}

export function readNotification(businessId, session_id) {
  return (dispatch) => {
    request
      .post(
        `${window.Config.API_URL}/livedashboard/business/session/${session_id}/notification/read`,
      )
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .set('Content-Type', 'application/json')
      .send(JSON.stringify('READ'))
      .then((resp) => {
        if (resp.statusCode === 200) {
          dispatch(postConversationRead(session_id));
        }
      })
      .catch((ex) => {
        console.log(ex);
      });
  };
}

export function postConversationRead(session_id) {
  return {
    type: types.CONVERSATION_READ,
    session: session_id,
  };
}

const getConversationTranscriptsStart = () => {
  return {
    type: types.GET_CONVERSATION_TRANSCRIPTS_START,
  };
};

const getConversationTranscriptsSuccess = (data) => {
  return {
    type: types.GET_CONVERSATION_TRANSCRIPTS_SUCCESS,
    data,
  };
};

const getConversationTranscriptsFail = () => {
  return {
    type: types.GET_CONVERSATION_TRANSCRIPTS_FAIL,
  };
};

export function getConversationTranscripts({
  businessId,
  userId,
  userName,
  start,
  end,
  sessionId,
}) {
  return (dispatch) => {
    dispatch(getConversationTranscriptsStart());

    const params = {
      business_id: businessId,
      user_id: userId,
      user_name: userName,
      start_time: start,
      end_time: end,
    };

    request
      .post(`${window.Config.API_URL}/livedashboard/business/transcripts`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(params)
      .then((resp) => {
        if (resp.statusCode === 200) {
          dispatch(
            getConversationTranscriptsSuccess({ sessionId, data: resp.body }),
          );
        } else {
          dispatch(getConversationTranscriptsFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(getConversationTranscriptsFail());
      });
  };
}

const postErrorReportStart = () => {
  return {
    type: types.POST_ERROR_REPORT_START,
  };
};

const postErrorReportSuccess = (response) => {
  return {
    type: types.POST_ERROR_REPORT_SUCCESS,
    response,
  };
};

const postErrorReportFail = () => {
  return {
    type: types.POST_ERROR_REPORT_FAIL,
  };
};

export function clearReportFlags() {
  return {
    type: types.POST_ERROR_REPORT_CLEAR,
  };
}
export function clearNotificationMessage() {
  return {
    type: types.CLEAR_NOTIFICATION_MESSAGE,
  };
}

export function postErrorReport({
  businessId,
  userId,
  name,
  number,
  sessionId,
  description,
  email,
}) {
  return (dispatch) => {
    dispatch(postErrorReportStart());

    const params = {
      bzId: businessId,
      error_description: description,
      user_id: userId,
      callerName: name,
      callerNumber: number,
      id: sessionId, // session_id
      bd_user: email, // BD login
    };

    request
      .post(`${window.Config.API_URL}/business/reportError`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(params)
      .then((resp) => {
        if (resp.statusCode === 200) {
          dispatch(postErrorReportSuccess(resp.body));
        } else {
          dispatch(postErrorReportFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(postErrorReportFail());
      });
  };
}

const postBlockUserStart = () => {
  return {
    type: types.POST_ERROR_REPORT_START,
  };
};

const postBlockUserSuccess = (response) => {
  return {
    type: types.POST_ERROR_REPORT_SUCCESS,
    response,
  };
};

const postBlockUserFail = () => {
  return {
    type: types.POST_ERROR_REPORT_FAIL,
  };
};

export function postBlockUser({
  businessId,
  number,
  blocked_by,
}) {
  return (dispatch) => {
    dispatch(postBlockUserStart());

    const params = {
      bz_id: businessId,
      user_phone: number,
      blocked_by,
      source: 'dashboard',
    };

    request
      .post(`${window.Config.API_URL}/business/blockedUser/add`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(params)
      .then((resp) => {
        if (resp.statusCode === 200) {
          resp.body.number = number;
          dispatch(postBlockUserSuccess(resp.body));
        } else {
          dispatch(postBlockUserFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(postBlockUserFail());
      });
  };
}

const unblockPhoneStart = () => {
  return {
    type: types.UNBLOCK_NUMBER_START,
  };
};

const unblockPhoneSuccess = (response) => {
  return {
    type: types.UNBLOCK_NUMBER_SUCCESS,
    response,
  };
};

const unblockPhoneFail = () => {
  return {
    type: types.UNBLOCK_NUMBER_FAIL,
  };
};

export function unblockPhone({
  businessId,
  number,
  blocked_by,
}) {
  return (dispatch) => {
    dispatch(unblockPhoneStart());

    const params = {
      bz_id: businessId,
      user_phone: number,
      blocked_by,
      source: 'dashboard',
    };

    request
      .del(`${window.Config.API_URL}/business/blockedUser/delete`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(params)
      .then((resp) => {
        if (resp.statusCode === 200) {
          resp.body.number = number;
          dispatch(unblockPhoneSuccess(resp.body));
        } else {
          dispatch(unblockPhoneFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(unblockPhoneFail());
      });
  };
}

const getBlockUserStart = () => {
  return {
    type: types.GET_BLOCKED_NUMBERS_START,
  };
};

const getBlockUserSuccess = (response) => {
  return {
    type: types.GET_BLOCKED_NUMBERS_SUCCESS,
    response,
  };
};

const getBlockUserFail = () => {
  return {
    type: types.GET_BLOCKED_NUMBERS_FAIL,
  };
};

export function getBlockUser(businessId) {
  return (dispatch) => {
    dispatch(getBlockUserStart());
    request
      .get(
        `${window.Config.API_URL}/business/blockedUser/get?bz_id=${businessId}`,
      )
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .then((resp) => {
        if (resp.statusCode === 200) {
          dispatch(getBlockUserSuccess(resp.body));
        } else {
          dispatch(getBlockUserFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(getBlockUserFail());
      });
  };
}

const getOptOutnumbersStart = () => {
  return {
    type: types.GET_OPT_OUT_NUMBERS_START,
  };
};

const getOptOutnumbersSuccess = (response) => {
  return {
    type: types.GET_OPT_OUT_NUMBERS_SUCCESS,
    response,
  };
};

const getOptOutnumbersFail = () => {
  return {
    type: types.GET_OPT_OUT_NUMBERS_FAIL,
  };
};

export function getOptOutnumbers(businessId) {
  return (dispatch) => {
    dispatch(getOptOutnumbersStart());
    request
      .get(
        `${window.Config.API_URL
        }/users/unsubscribed/recent/?id=${businessId}&count=5&end_time_large=${moment()
          .add(2, 'd')
          .format('YYYY-MM-DDT00:00:00')}&start_time_large=${moment()
          .subtract(6, 'months')
          .format('YYYY-MM-DDT00:00:00')}&end_time_small=${moment()
          .add(2, 'd')
          .format('YYYY-MM-DDT00:00:00')}&start_time_small=${moment()
          .subtract(16, 'd')
          .format('YYYY-MM-DDT00:00:00')}`,
      )
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .then((resp) => {
        if (resp.statusCode === 200) {
          dispatch(getOptOutnumbersSuccess(resp.body));
        } else {
          dispatch(getOptOutnumbersFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(getOptOutnumbersFail());
      });
  };
}

const getOptOutReportStart = () => {
  return {
    type: types.GET_OPT_OUT_REPORT_START,
  };
};

const getOptOutReportSuccess = (response) => {
  return {
    type: types.GET_OPT_OUT_REPORT_SUCCESS,
  };
};

const getOptOutReportFail = () => {
  return {
    type: types.GET_OPT_OUT_REPORT_FAIL,
  };
};

export function getOptOutReport(businessId, filename) {
  return (dispatch) => {
    dispatch(getOptOutReportStart());
    request
      .get(
        `${window.Config.API_URL
        }/users/unsubscribed/report/?id=${businessId}&end_time=${moment()
          .add(2, 'd')
          .format('YYYY-MM-DDT00:00:00.000')}&start_time=${moment()
          .subtract(6, 'months')
          .format('YYYY-MM-DDT00:00:00.000')}`,
      )
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .then((resp) => {
        if (resp.statusCode === 200) {
          const blob = new Blob([resp.text], {
            type: 'text/csv/jpeg/jpg/png/pdf/docx/doc;charset=utf8;',
          });
          const element = document.createElement('a');
          document.body.appendChild(element);
          element.download = filename;
          element.href = window.URL.createObjectURL(blob);
          element.style.display = '';
          element.click();
          dispatch(getOptOutReportSuccess());
        } else {
          dispatch(getOptOutReportFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(getOptOutReportFail());
      });
  };
}

const changeAutoResponseStart = () => {
  return {
    type: types.POST_AUTO_RESPONSE_START,
  };
};

const changeAutoResponseSuccess = (response, sessionId) => {
  return {
    type: types.POST_AUTO_RESPONSE_SUCCESS,
    response,
    sessionId,
  };
};

const changeAutoResponseFail = () => {
  return {
    type: types.POST_AUTO_RESPONSE_FAIL,
  };
};

export function changeAutoResponse(sessionId, status) {
  return (dispatch) => {
    dispatch(changeAutoResponseStart());
    request
      .post(
        `${window.Config.API_URL}/livedashboard/business/session/${sessionId}/auto_chat`,
      )
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send({ status })
      .then((resp) => {
        if (resp.statusCode === 200) {
          dispatch(changeAutoResponseSuccess(resp.body, sessionId));
        } else {
          dispatch(changeAutoResponseFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(changeAutoResponseFail());
      });
  };
}

const sendMessageStart = () => {
  return {
    type: types.POST_MESSAGE_START,
  };
};

const sendMessageSuccess = (response) => {
  return {
    type: types.POST_MESSAGE_SUCCESS,
    response,
  };
};

const sendMessageFail = () => {
  return {
    type: types.POST_MESSAGE_FAIL,
  };
};

export function sendMessage(data) {
  return (dispatch) => {
    dispatch(sendMessageStart());
    request
      .post(
        `${window.Config.API_URL}/livedashboard/business/session/${data.session_id}/message`,
      )
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(data)
      .then((resp) => {
        if (resp.statusCode === 200) {
          dispatch(sendMessageSuccess(resp.body));
        } else {
          dispatch(sendMessageFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(sendMessageFail());
      });
  };
}

const searchContactStart = (isAdvancedSearch) => {
  return {
    type: types.SEARCH_CONTACT_START,
    isAdvancedSearch,
  };
};

const searchContactSuccess = (response, isAdvancedSearch) => {
  return {
    type: types.SEARCH_CONTACT_SUCCESS,
    response,
    isAdvancedSearch,
  };
};

const searchContactFail = () => {
  return {
    type: types.SEARCH_CONTACT_FAIL,
  };
};

export function searchContact(business_id, query, isAdvancedSearch) {
  return (dispatch) => {
    dispatch(searchContactStart(isAdvancedSearch));
    let search_url = `${window.Config.API_URL}/livedashboard/business/client?business_id=${business_id}&query=${query}`;
    if (isAdvancedSearch) {
      search_url = `${window.Config.API_URL}/livedashboard/business/client?business_id=${business_id}&first_name=${query.first_name}&last_name=${query.last_name}&email=${query.email}&phone=${query.phone}`;
    }
    request
      .get(search_url)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .then((resp) => {
        if (resp.statusCode === 200) {
          dispatch(searchContactSuccess(resp.body, isAdvancedSearch));
        } else {
          dispatch(searchContactFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(searchContactFail());
      });
  };
}
const createNewConversationStart = (skeliton, selectedLocation) => {
  return {
    type: types.CREATE_CONVERSATION,
    skeliton,
    selectedLocation,
  };
};
export function createNewConversation(auth, business, selectedLocation) {
  return (dispatch) => {
    const { id, clientUser } = business;
    const skeliton = {
      bookings: [],
      messages: [],
      notifications: [],
      events: [],
      voice_mails: [],
      lead_engage_campaign: {},
      notes: {
        conversation_notes: [],
      },
      action: 'NONE',
      action_updated_by: 'TrueLark',
      action_updated_time: new Date().getTime(),
      auto_chat_status: 'PAUSED',
      auto_chat_status_updated_by: null,
      auto_chat_status_updated_time: null,
      notification_status: 'NONE',
      notification_read_status: 'READ',
      unread_count: 0,
      id: uuidv4(),
      bzId: '504318',
      userId: uuidv4(),
      userPhone: '',
      userName: '',
      startTime: new Date().getTime(),
      endTime: new Date().getTime(),
      initiator: 'BOT_INITIATED',
      status: 'NEW_SESSION',
      lastQuickAction: 'QA_NONE',
      lastMessageTime: 0,
      lastMessageSender: null,
      userResponded: false,
      lastMessageIsQuestion: false,
      textType: 'SMS',
      feedback: {},
      associated_clients: [],
      created_clients: [],
      showConversation: 'SHOW',
      messageKind: 'TWILIO',
      initiatedBy: {
        initiatorType: 'STAFF',
        initiatorId: clientUser.email,
      },
      initiatedFor: 'SMS',
      campaignId: 'null',
      hasUserMessage: false,
      tags: [],
      accounts: [selectedLocation.studioId],
      workflow_task: '',
      new_client_created: false,
      inference: 'NONE',
      staffCreated: true,
      newlyCreated: true,
      createdBy: auth.userid,
    };
    dispatch(createNewConversationStart(skeliton, selectedLocation));
  };
}
export function removeConversation(id) {
  return (dispatch) => {
    dispatch({
      type: types.REMOVE_CONVERSATION,
      id,
    });
  };
}

const createConversationInBackendStart = () => {
  return {
    type: types.CREATE_CONVERSATION_START,
  };
};
const createConversationInBackendSuccess = (session_id, data) => {
  return {
    type: types.CREATE_CONVERSATION_SUCCESS,
    session_id,
    data,
  };
};
const createConversationInBackendFail = () => {
  return {
    type: types.CREATE_CONVERSATION_FAIL,
  };
};
export function createConversationInBackend(business_id, session_id, data) {
  return (dispatch) => {
    dispatch(createConversationInBackendStart());
    request
      .post(
        `${window.Config.API_URL}/livedashboard/business/${business_id}/conversation`,
      )
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(data)
      .then((resp) => {
        if (resp.statusCode === 200) {
          dispatch(createConversationInBackendSuccess(session_id, resp.body));
        } else {
          dispatch(sendMessageFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(createConversationInBackendFail());
      });
  };
}

const getConvMetricstart = () => {
  return {
    type: types.GET_CONVERSATION_METRICS_START,
  };
};
const getConvMetricsuccess = (data) => {
  return {
    type: types.GET_CONVERSATION_METRICS_SUCCESS,
    data,
  };
};
const getConvMetricFail = () => {
  return {
    type: types.GET_CONVERSATION_METRICS_FAIL,
  };
};
export function getConvMetric(businessId) {
  return (dispatch) => {
    let no_of_days = 30;
    let startdate = moment()
      .startOf('day')
      .subtract(no_of_days, 'd');
    startdate = Math.round(new Date(startdate).getTime());
    let endDate = Math.round(new Date().getTime());
    const params = Object.assign(
      {},
      {
        start_time: startdate,
        end_time: endDate,
        business_id: businessId,
      },
    );
    dispatch(getConvMetricstart());
    request
      .post(`${window.Config.API_URL}/business/dashboard/statistics`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(params)
      .then((resp) => {
        if (resp.statusCode === 200) {
          dispatch(getConvMetricsuccess(resp.body));
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(getConvMetricFail());
      });
  };
}

export function minimizeSidbar(flag) {
  return (dispatch) => {
    dispatch({
      type: types.MINIMIZE_SIDEBAR,
      flag,
    });
  };
}

export function clearNewlyCreatedFlags() {
  return (dispatch) => {
    dispatch({
      type: types.CLEAR_NEWLY_CREATED_SELECTION,
    });
  };
}
export function clearJumpSelectionFlags() {
  return (dispatch) => {
    dispatch({
      type: types.CLEAR_JUMP_SELECTION,
    });
  };
}
export function clearContactFlag(session_id) {
  return (dispatch) => {
    dispatch({
      type: types.CLEAR_CONTACT_FLAG,
      session_id,
    });
  };
}
export function selectContactforNewSession(session_id, contact) {
  return (dispatch) => {
    dispatch({
      type: types.SELECT_CONTACT_FOR_SESSION,
      session_id,
      contact,
    });
  };
}

const createContactInBackendStart = () => {
  return {
    type: types.CREATE_CONTACT_START,
  };
};
const createContactInBackendSuccess = (session_id, data, isNewlyCreated) => {
  return {
    type: types.CREATE_CONTACT_SUCCESS,
    session_id,
    data,
    isNewlyCreated,
  };
};
const createContactInBackendFail = () => {
  return {
    type: types.CREATE_CONTACT_FAIL,
  };
};
export function createContactInBackend(
  business_id,
  session_id,
  data,
  isNewlyCreated,
) {
  return (dispatch) => {
    dispatch(createContactInBackendStart());
    request
      .post(
        `${window.Config.API_URL}/livedashboard/business/${business_id}/client`,
      )
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(data)
      .then((resp) => {
        if (resp.statusCode === 200) {
          dispatch(
            createContactInBackendSuccess(
              session_id,
              resp.body,
              isNewlyCreated,
            ),
          );
        } else {
          dispatch(sendMessageFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(createContactInBackendFail());
      });
  };
}

export function scoketHandshake(user_id, businessId) {
  console.log(
    'window.Config.WEBSOCKET_API_URL',
    window.Config.WEBSOCKET_API_URL,
  );
  return (dispatch) => {
    if (ws) {
      ws.removeEventListener('close', wsClose);
      ws.close();
      ws = null;
    }
    ws = new WebSocket(
      `${window.Config.WEBSOCKET_API_URL}/v1/messages?client_id=${user_id}&business_id=${businessId}`,
      [],
      {
        debug: true,
      },
    );

    ws.addEventListener('close', wsClose);
    ws.addEventListener('message', (event) => {
      dispatch({
        type: types.GET_CONVERSATION_MESSAGE,
        action: JSON.parse(event.data),
      });
    });
    ws.addEventListener('error', onWSError);
  };
}

const wsClose = (data) => {
  if (data.code === 1000) {
    console.log('1000 received on ws. Attempt force logout.');
    // forceLogout();
  } else if (data.code === 3000) {
    console.log('3000 received on ws. Attempt force logout.');
    const { dispatch } = store;
    dispatch(userLogout());
  }
};

const onWSError = (err) => {
  console.log('Socket connection error', err);
};

export function disconnectScoket() {
  return (dispatch) => {
    if (ws) {
      ws.removeEventListener('close', wsClose);
      ws.removeEventListener('message', (event) => {
        dispatch({
          type: types.GET_CONVERSATION_MESSAGE,
          action: JSON.parse(event.data),
        });
      });
      ws.removeEventListener('error', onWSError);
      ws.close();
      ws = null;
    }
  };
}

export function changeStoreLocation(location) {
  return (dispatch) => {
    dispatch({ type: types.CONVERSATION_LOCATION_CHANGE, location });
  };
}

export function attentionCount(count) {
  return (dispatch) => {
    dispatch({ type: types.ATTENTION_COUNT, count });
  };
}

/* ========= getCustomTags API ========= */

const getCustomTagsStart = () => ({
  type: types.GET_CUSTOM_TAGS_START,
});

const getCustomTagsSuccess = (data) => ({
  type: types.GET_CUSTOM_TAGS_SUCCESS,
  data,
});

const getCustomTagsFail = () => ({
  type: types.GET_CUSTOM_TAGS_FAIL,
});

export function getCustomTags(params) {
  return (dispatch) => {
    dispatch(getCustomTagsStart());
    request
      .get(`${window.Config.API_URL}/business/preferences/custom_tags`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .then((resp) => {
        if (resp.statusCode === 200) {
          const data = JSON.parse(resp.text);
          dispatch(getCustomTagsSuccess(data));
        } else {
          dispatch(getCustomTagsFail());
        }
      })
      .catch((ex) => {
        console.error(ex);
        dispatch(getCustomTagsFail());
      });
  };
}

/* ========= addCustomTags API ========= */

const addCustomTagsStart = () => ({
  type: types.ADD_CUSTOM_TAGS_START,
});

const addCustomTagsSuccess = (data) => ({
  type: types.ADD_CUSTOM_TAGS_SUCCESS,
  data,
});

const addCustomTagsFail = () => ({
  type: types.ADD_CUSTOM_TAGS_FAIL,
});

export function addCustomTags(params) {
  return (dispatch) => {
    dispatch(addCustomTagsStart());
    request
      .post(`${window.Config.API_URL}/business/preferences/custom_tags/create`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(params)
      .then((resp) => {
        if (resp.statusCode === 200) {
          const data = JSON.parse(resp.text);
          dispatch(addCustomTagsSuccess(data));
        } else {
          dispatch(addCustomTagsFail());
        }
      })
      .catch((ex) => {
        console.error(ex);
        dispatch(addCustomTagsFail());
      });
  };
}

/* ========= deleteCustomTag API ========= */

const deleteCustomTagStart = () => ({
  type: types.DELETE_CUSTOM_TAG_START,
});

const deleteCustomTagSuccess = (data) => ({
  type: types.DELETE_CUSTOM_TAG_SUCCESS,
  data,
});

const deleteCustomTagFail = () => ({
  type: types.DELETE_CUSTOM_TAG_FAIL,
});

export function deleteCustomTag(params) {
  return (dispatch) => {
    dispatch(deleteCustomTagStart());
    request
      .del(`${window.Config.API_URL}/business/preferences/custom_tags/remove`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(params)
      .then((resp) => {
        if (resp.statusCode === 200) {
          const data = JSON.parse(resp.text);
          dispatch(deleteCustomTagSuccess(data));
        } else {
          dispatch(deleteCustomTagFail());
        }
      })
      .catch((ex) => {
        console.error(ex);
        dispatch(deleteCustomTagFail());
      });
  };
}

/* ========= addTagToUser API ========= */

const addTagToUserStart = () => ({
  type: types.ADD_TAG_TO_USER_START,
});

const addTagToUserSuccess = (data, conversation) => ({
  type: types.ADD_TAG_TO_USER_SUCCESS,
  data,
  conversation,
});

const addTagToUserFail = () => ({
  type: types.ADD_TAG_TO_USER_FAIL,
});

export function addTagToUser(params, conversation) {
  return (dispatch) => {
    dispatch(addTagToUserStart());
    request
      .post(`${window.Config.API_URL}/livedashboard/business/user/${conversation.userId}/tags`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(params)
      .then((resp) => {
        if (resp.statusCode === 200) {
          const data = JSON.parse(resp.text);
          dispatch(addTagToUserSuccess(data, conversation));
        } else {
          dispatch(addTagToUserFail());
        }
      })
      .catch((ex) => {
        console.error(ex);
        dispatch(addTagToUserFail());
      });
  };
}

/* ========= removeTagofUser API ========= */

const removeTagofUserStart = () => ({
  type: types.REMOVE_TAGOF_USER_START,
});

const removeTagofUserSuccess = (data, conversation) => ({
  type: types.REMOVE_TAGOF_USER_SUCCESS,
  data,
  conversation,
});

const removeTagofUserFail = () => ({
  type: types.REMOVE_TAGOF_USER_FAIL,
});

export function removeTagofUser(params, conversation) {
  return (dispatch) => {
    dispatch(removeTagofUserStart());
    request
      .del(`${window.Config.API_URL}/livedashboard/business/user/${conversation.userId}/tags`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(params)
      .then((resp) => {
        if (resp.statusCode === 200) {
          const data = JSON.parse(resp.text);
          dispatch(removeTagofUserSuccess(data, conversation));
        } else {
          dispatch(removeTagofUserFail());
        }
      })
      .catch((ex) => {
        console.error(ex);
        dispatch(removeTagofUserFail());
      });
  };
}
